import React from 'react';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

export default function ErrorBanner({ errMsg }: {
  errMsg: string
}) {
  if (!errMsg) return null;
  return (
    <div className='bg-pure-red-50 border border-pure-red-500 rounded-md py-3.5 px-4 flex items-center gap-2'>
      <InfoRoundedIcon className='text-pure-red-500' fontSize='small'/>
      {errMsg}</div>
  );
}
